function slots() {
  $(".slot__button--item").on("click", function () {
    var currentSlotAmount;
    let slotCost;
    const currency = $("#slot_cost").attr("data-currency");
    const rate = $("#slot_cost").attr("data-rate");
    const slotTime = parseInt($("#slot_time").attr("data-time"));
    const slotCurrentTime = parseInt($("#slot_time").text());
    const agency = $("#agency").val();

    if (currency !== "SEK") {
      slotCost = parseFloat($("#slot_cost").val());
      currentSlotAmount = parseFloat(
        $("#payTotalSlotAmount").attr("data-amount")
      );
    } else {
      slotCost = parseInt($("#slot_cost").val());
      currentSlotAmount = parseInt(
        $("#payTotalSlotAmount").attr("data-amount")
      );
    }

    if ($(this).attr("data-slot") == "reduce") {
      var amountToPay = currentSlotAmount - slotCost;
      if (currency !== "SEK") {
        amountToPay = roundToTwoDecimalPlaces(amountToPay);
      }
      $("#slot_time").text(slotCurrentTime - slotTime);
    }
    if ($(this).attr("data-slot") == "add") {
      var amountToPay = currentSlotAmount + slotCost;
      if (currency !== "SEK") {
        amountToPay = roundToTwoDecimalPlaces(amountToPay);
      }

      $("#slot_time").text(slotCurrentTime + slotTime);
    }

    $("#payTotalSlotAmount").attr("data-amount", amountToPay);
    $(".slot-amount").val(amountToPay);
    $(".slot-amount").attr("value", amountToPay);
    $("#payTotalSlotAmount").text(amountToPay);
    $("#payTotalSlotAmountButton").attr("data-alg_open_price", amountToPay);

    var oldUrl = $("#payTotalSlotAmountButton").attr("data-href");
    var newUrl = oldUrl + "&alg_open_price=" + amountToPay;

    if (agency) {
      newUrl = newUrl + "&agency=" + agency;
    }

    $("#payTotalSlotAmountButton").attr("href", newUrl);

    if (amountToPay == slotCost) {
      $(".slot__button--item[data-slot=reduce]").prop("disabled", true);
    } else {
      $(".slot__button--item[data-slot=reduce]").prop("disabled", false);
    }
  });

  function roundToTwoDecimalPlaces(number) {
    return Math.round((number + Number.EPSILON) * 100) / 100;
  }

  function roundToNearestInteger(number) {
    return Math.round(number);
  }
}
export default slots;
